module.exports = __webpack_public_path__ + "img/20190627162249640.fc2ccdf6.png";